module.exports = __webpack_public_path__ + "static/img/banner-msg.c629fb51.png";